<script>
  import { createEventDispatcher } from 'svelte';
  import { filteredAlertCounts } from '../store';

  const dispatch = createEventDispatcher();

  let sortedAlertCounts = [];

  const columns = {
    ACCOUNT_NAME: 'account_name',
    RESET_DATE: 'last_reset',
    DAYS_UNTIL_RESET: 'days_until_reset',
    ALERTS_INCLUDED: 'included_alerts',
    SMS_USED: 'sms',
    VOICE_USED: 'voice',
    EMAIL_USED: 'email',
    ALERTS_REMAINING: 'remainingAlerts'
  }

  const order = {
    ASCENDING: 'ASCENDING',
    DESCENDING: 'DESCENDING'
  };

  let sortColumn = columns.ACCOUNT_NAME;
  let sortOrder = order.ASCENDING;

  $: {
    switch (sortColumn) {
      case columns.ACCOUNT_NAME:
        if (sortOrder === order.ASCENDING) {
          sortedAlertCounts = $filteredAlertCounts.sort((a, b) => {
            const aName = a.account_name;
            const bName = b.account_name;
            if (aName < bName) return -1;
            if (aName > bName) return 1
            return 0;
          }) 
        } else {
          sortedAlertCounts = $filteredAlertCounts.sort((a, b) => {
            const aName = a.account_name;
            const bName = b.account_name;
            if (aName < bName) return 1;
            if (aName > bName) return -1
            return 0;
          });
        }
        break;
      case columns.RESET_DATE:
        sortedAlertCounts = $filteredAlertCounts.sort((a, b) => {
          const aReset = isNaN(new Date(a.last_reset).getTime()) ?  new Date('2000-01-01') : new Date(a.last_reset); 
          const bReset = isNaN(new Date(b.last_reset).getTime()) ? new Date('2000-01-01') : new Date(b.last_reset);
          if(sortOrder === order.ASCENDING) {
            return aReset - bReset;
          } else {
            return bReset - aReset;
          }
        });
        break;
      case columns.DAYS_UNTIL_RESET:
      case columns.ALERTS_INCLUDED:
      case columns.ALERTS_REMAINING:
        sortedAlertCounts = $filteredAlertCounts.sort((a, b) => {
          const aColumn = isNaN(a[sortColumn]) ?  0 : a[sortColumn]; 
          const bColumn = isNaN(b[sortColumn]) ? 0 : b[sortColumn];
          if(sortOrder === order.ASCENDING) {
            return aColumn - bColumn;
          } else {
            return bColumn - aColumn;
          }
        });
        break;
      case columns.EMAIL_USED:
      case columns.SMS_USED:
      case columns.VOICE_USED:
        sortedAlertCounts = $filteredAlertCounts.sort((a, b) => {
          const aCounts = isNaN(a.alertCount[sortColumn]) ? 0 : a.alertCount[sortColumn];
          const bCounts = isNaN(b.alertCount[sortColumn]) ? 0 : b.alertCount[sortColumn];
          if(sortOrder === order.ASCENDING) {
            return aCounts - bCounts;
          } else {
            return bCounts - aCounts;
          }
        })
        break;
      default:
        break;
    }  
  }

  const setSortColumnAndOrder = (order, column) => {
    sortOrder = order;
    sortColumn = column;
  }

</script>
<div class="row">
  <div class="col-md-12 stretch-card">
    <div class="card">
      <div class="card-body">
        <p class="card-title">Customer Alerts Used</p>
        <div class="table-responsive">
          <table id="residents" class="table table-bordered table-sm">
            <thead>
              <tr>
                <th>
                  Customer<br>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16" on:click={()=>setSortColumnAndOrder(order.ASCENDING, columns.ACCOUNT_NAME)}>
                    <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16" on:click={()=>setSortColumnAndOrder(order.DESCENDING, columns.ACCOUNT_NAME)}>
                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </th>
                <th class='text-center'>
                  Reset Date<br>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16" on:click={()=>setSortColumnAndOrder(order.ASCENDING, columns.RESET_DATE)}>
                    <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16" on:click={()=>setSortColumnAndOrder(order.DESCENDING, columns.RESET_DATE)}>
                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </th>
                <th class='text-center'>
                  Days until Reset<br>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16" on:click={()=>setSortColumnAndOrder(order.ASCENDING, columns.DAYS_UNTIL_RESET)}>
                    <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16" on:click={()=>setSortColumnAndOrder(order.DESCENDING, columns.DAYS_UNTIL_RESET)}>
                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </th>
                <th class='text-center'>
                  Alerts Included<br>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16" on:click={()=>setSortColumnAndOrder(order.ASCENDING, columns.ALERTS_INCLUDED)}>
                    <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16" on:click={()=>setSortColumnAndOrder(order.DESCENDING, columns.ALERTS_INCLUDED)}>
                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </th>
                <th class='text-center'>
                  SMS Used<br>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16" on:click={()=>setSortColumnAndOrder(order.ASCENDING, columns.SMS_USED)}>
                    <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16" on:click={()=>setSortColumnAndOrder(order.DESCENDING, columns.SMS_USED)}>
                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </th>
                <th class='text-center'>
                  Voice Used<br>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16" on:click={()=>setSortColumnAndOrder(order.ASCENDING, columns.VOICE_USED)}>
                    <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16" on:click={()=>setSortColumnAndOrder(order.DESCENDING, columns.VOICE_USED)}>
                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </th>
                <th class='text-center'>
                  Email Used<br>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16" on:click={()=>setSortColumnAndOrder(order.ASCENDING, columns.EMAIL_USED)}>
                    <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16" on:click={()=>setSortColumnAndOrder(order.DESCENDING, columns.EMAIL_USED)}>
                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </th>
                <th class='text-center'>
                  Alerts Remaining<br>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16" on:click={()=>setSortColumnAndOrder(order.ASCENDING, columns.ALERTS_REMAINING)}>
                    <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16" on:click={()=>setSortColumnAndOrder(order.DESCENDING, columns.ALERTS_REMAINING)}>
                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </th>
              </tr>
            </thead>
            <tbody>
              {#each sortedAlertCounts as accountData}
                <tr on:click={dispatch('goToAccount', accountData.account_id)}> 
                  <td>{accountData.account_name}</td>
                  <td class='text-center'>{accountData.last_reset}</td>
                  <td 
                    class='text-center'
                    class:success='{accountData.days_until_reset <= 30}'
                    class:danger='{accountData.days_until_reset < 30}'>
                    {accountData.days_until_reset}
                  </td>
                  <td class='text-center'>{accountData.included_alerts}</td>
                  <td class='text-center'>{accountData.alertCount.sms}</td>
                  <td class='text-center'>{accountData.alertCount.voice}</td>
                  <td class='text-center'>{accountData.alertCount.email}</td>
                  <td 
                    class='text-center'
                    class:success='{accountData.remainingAlerts >= 500}'
                    class:danger='{accountData.remainingAlerts < 500}'>
                      {accountData.remainingAlerts}
                  </td>
                </tr>
              {/each}
            </tbody>
            <!-- <tfoot>
              <tr>
                <td colspan='5'>
                  <nav class='mt-2' aria-label="Page navigation">
                    <Pagination items={$filteredAccounts} on:paginate={paginate}></Pagination>
                  </nav>
                </td>
              </tr>
            </tfoot> -->
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  td.success {
    color: green;
  }

  td.danger {
    color: red;
    font-weight: bold;
  }

  tr {
    cursor: pointer;
  }
</style>